module.exports = __webpack_public_path__ + "static/media/default_product_image.af0cb0ab.png";